export enum FollowupType {
  MATERNAL = 'MATERNAL',

  NEONATAL = 'NEONATAL',
}
